import React, { PureComponent, Fragment } from 'react';
import styles from './Player.module.css';

const playerEl = document.createElement('div');
playerEl.id = 'playerEl';
playerEl.className = styles.player;

export default class Player extends PureComponent {
  async componentWillReceiveProps(props) {
    const { initializePlayer, asset, importFile, setLoading } = this.props;
    if (props.asset !== asset) {
      this.refs['playerParent'].appendChild(playerEl);
      initializePlayer(props.asset.claraUuid, 'playerEl', {});
    }
    if (props.file !== this.props.file) {
      setLoading(true);
      await importFile(props.file);
      setLoading(false);
    }
  }

  async componentDidMount() {
    const { asset, initializePlayer, type, file, setLoading } = this.props;
    if (asset && asset.claraUuid) {
      this.refs['playerParent'].appendChild(playerEl);
      initializePlayer(asset.claraUuid, 'playerEl', {});
    } else if (type === 'spotpoint') {
      this.refs['playerParent'].appendChild(playerEl);
      await initializePlayer('playerEl', file);
      setLoading(false);
    }
  }

  render() {
    return <div ref="playerParent" />;
  }
}



// WEBPACK FOOTER //
// ./src/components/Player/index.js